// Merchant3 translation imports
import ceb_PH from "./jsons/ceb_PH.json";
import en_CO from "./jsons/en_CO.json";
import en_EC from "./jsons/en_EC.json";
import en_ID from "./jsons/en_ID.json";
import en_MX from "./jsons/en_MX.json";
import en_PA from "./jsons/en_PA.json";
import en_PE from "./jsons/en_PE.json";
import en_PH from "./jsons/en_PH.json";
import en_US from "./jsons/en_US.json";
import en_ZA from "./jsons/en_ZA.json";
import es_CO from "./jsons/es_CO.json";
import es_EC from "./jsons/es_EC.json";
import es_MX from "./jsons/es_MX.json";
import es_PA from "./jsons/es_PA.json";
import es_PE from "./jsons/es_PE.json";
import es_PT from "./jsons/es_PT.json";
import es_US from "./jsons/es_US.json";
import es_ZA from "./jsons/es_ZA.json";
import fil_PH from "./jsons/fil_PH.json";
import id_ID from "./jsons/id_ID.json";
import nr_ZA from "./jsons/nr_ZA.json";
import nso_ZA from "./jsons/nso_ZA.json";
import pt_BR from "./jsons/pt_BR.json";
import ss_ZA from "./jsons/ss_ZA.json";
import st_ZA from "./jsons/st_ZA.json";
import tl_PH from "./jsons/tl_PH.json";
import tn_ZA from "./jsons/tn_ZA.json";
import ts_ZA from "./jsons/ts_ZA.json";
import ve_ZA from "./jsons/ve_ZA.json";
import xh_ZA from "./jsons/xh_ZA.json";
import zu_ZA from "./jsons/zu_ZA.json";

// Export merchant3 specific translations
export default {
  ceb_PH,
  en_CO,
  en_EC,
  en_ID,
  en_MX,
  en_PA,
  en_PE,
  en_PH,
  en_US,
  en_ZA,
  es_CO,
  es_EC,
  es_MX,
  es_PA,
  es_PE,
  es_PT,
  es_US,
  es_ZA,
  fil_PH,
  id_ID,
  nr_ZA,
  nso_ZA,
  pt_BR,
  ss_ZA,
  st_ZA,
  tl_PH,
  tn_ZA,
  ts_ZA,
  ve_ZA,
  xh_ZA,
  zu_ZA,
};

